const excludedPages = ['/messaging'];

export default excludedPages;
